<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 2C16.2652 2 16.5196 2.10536 16.7071 2.29289L21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V15C22 15.2339 21.918 15.4605 21.7682 15.6402L16.7682 21.6402C16.5782 21.8682 16.2968 22 16 22H8C7.73478 22 7.48043 21.8946 7.29289 21.7071L2.29289 16.7071C2.10536 16.5196 2 16.2652 2 16V8C2 7.73478 2.10536 7.48043 2.29289 7.29289L7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H16ZM15.5858 4H8.41421L4 8.41421V15.5858L8.41421 20H15.5316L20 14.6379V8.41421L15.5858 4ZM12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16ZM12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6Z"
    fill="currentColor"
  />
</svg>
